module.exports = __webpack_public_path__ + "static/media/truck-icon.ecfa480a.svg";